<template>
	<div id="app">
		<Background ref="background" />
		<span class="site-title">ROBOT D</span>
		<nav class="nav">
			<ul class="nav-list">
				<li class="nav-li"><router-link to="/" exact class="nav-link" v-on:click.native="handleNavClick">About</router-link></li>
				<li class="nav-li"><router-link to="/cv" class="nav-link" v-on:click.native="handleNavClick">CV</router-link></li>
				<li class="nav-li"><router-link to="/work" class="nav-link" v-on:click.native="handleNavClick">Work</router-link></li>
			</ul>
		</nav>
		<div class="content">
			<router-view />
		</div>
	</div>
</template>

<script type="text/babel">
	import Background from './components/Background.vue';
	import browser from 'detect-browser';

	let body = document.body;
	body.classList.add('is-' + browser.name);

	if(/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
		body.classList.add('is-ios');
	}

	export default {
		name: 'app',
		components: {Background},
		methods: {
			handleNavClick: function() {
				this.$refs.background.handleNavClick();
			}
		}
	}
</script>

<style lang="scss">
	#app {
		margin: 0;
		top: 0;
		position: relative;
	}

	.slide-fade-enter-active {
		transition: all .8s ease;
	}

	.slide-fade-enter, .slide-fade-leave-active {
		transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}

	.slide-fade-enter {
		transition: all .2s cubic-bezier(1.0, 0.8, 0.5, 1.0);
		transform: perspective(1000px) translate3d(-600px, 50px, 0) rotate3d(0,1,0,40deg);
		opacity: 0;
	}

	.slide-fade-leave-active {
		transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
		transform: perspective(1000px) translate3d(600px, 50px, 0) rotate3d(0,1,0,-40deg);
		opacity: 0;
	}

	.is-safari .slide-fade-enter,
	.is-ios    .slide-fade-enter,
	.is-safari .slide-fade-leave-active,
	.is-ios    .slide-fade-leave-active {
		-webkit-transform: none;
	}

	.site-title {
		position: relative;
		display: block;
		font-family: SalaryMan, Helvetica, sans-serif;
		font-weight: normal;
		font-size: 72px;
		margin: 70px 0 10px;
		padding: 0;
		text-align: center;
		text-shadow: 0 8px 0 rgb(133, 186, 175), 0 16px 0 rgb(154, 144, 173);
		line-height: 1;
		-webkit-transform: perspective(1000px);
		z-index:100;
	}

	.nav {
		display: block;
		position: relative;
		text-align: center;
		margin: 0 auto;
		-webkit-transform: perspective(1000px);
		z-index:101;
	}

	.nav-list {
		list-style: none;
		padding: 0;
	}

	.nav-li {
		display: inline;
		margin-right: 75px;
	}

	.nav-li:last-child {
		margin-right: 0;
	}

	.nav-link {
		font-family: 'Droid Serif', Georgia, serif;
		font-style: italic;
		font-weight: bold;
		color: #fff;
		text-decoration: none;
		text-shadow: -2px 2px 0 rgb(154, 144, 173);
		outline: 0;
	}

	.nav-link.router-link-active {
		text-shadow: -2px 2px 0 #2F4F72;
		cursor: default;
	}

	.nav-link.router-link-active:hover {
		color: #fff;
	}

	.content {
		position: relative;
		top: 70px;
		max-width: 800px;
		min-width: 320px;
		margin: 0 auto;
	}

	.page {
		position: absolute;
		margin: 0 50px 200px;
		transform-origin: top center;
	}

	@media only screen and (max-width: 600px) {
		.site-title {
			font-size: 40px;
			margin-top: 20px;
		}
		.content {
			top: 40px;
		}
		.page {
			margin: 0 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// App.vue?3aa35272